import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core'
import { createApolloProvider } from '@vue/apollo-option'

export function generateApolloProvider() {
  const defaultOptions = {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  }
  const publicHttpLink = new HttpLink({
    uri: '/public_api/graphql'
  })

  const cacheForPublicClient = new InMemoryCache()

  const publicClient = new ApolloClient({
    link: publicHttpLink,
    cache: cacheForPublicClient,
    defaultOptions
  })

  const apolloProvider = createApolloProvider({
    clients: {
      publicClient
    },
    defaultClient: publicClient
  })

  return apolloProvider
}
